import script from "./CommunityPostDetail.vue?vue&type=script&setup=true&lang=js"
export * from "./CommunityPostDetail.vue?vue&type=script&setup=true&lang=js"

import "./CommunityPostDetail.vue?vue&type=style&index=0&id=ac8e8180&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-ac8e8180"]])

export default __exports__